<script>
export default {
  functional: true,
  render(
    h,
    {
      props: { option = {}, data = {} }
    }
  ) {
    const startColor = ['#4090EF', '#4CEBC9', '#FFEE3D']
    const endColor = ['#6B3EF2', '#10CAEA', '#E53C3D']
    const resultData = [
      { value: data.box_count, name: '代码岛' },
      { value: data.ide_count, name: '源码编辑器' },
      { value: data.wood_count, name: 'wood编辑器' }
    ]
    const colorData = resultData
      .filter(v => !!v.value)
      .map((v, i) => {
        v.itemStyle = {
          normal: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: startColor[i] // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: endColor[i] // 100% 处的颜色
                }
              ],
              globalCoord: false // 缺省为 false
            }
          }
        }
        return v
      })
    return (
      <div class="position-relative">
        <div class="float">
          <p class="score">{data.total}</p>
          <p class="sub">作品总数</p>
        </div>
        <pie-charts option={option} data={colorData} />
      </div>
    )
  }
}
</script>
<style lang="stylus" scoped>
.score
  color $themeColor
  font-size 24px
  line-height 24px
  font-weight bold
  margin-bottom 5px
.sub
  font-size 12px
  color #666
.float
  flex-column-center()
  position absolute
  z-index -1
  width 100%
  height 100%
</style>
